import * as angular from "angular";
import {IController} from "angular";
import {Addition} from "../../models/addition.model";

export class AdditionsTableRowCtrl implements IController {

  additionsTableCtrl: IController;
  addition: Addition;
  settingsValue: any;
  onPriceChange: Function
  onSettingsValueChange: Function;

  private siteCurrencySymbol: any;

  /* @ngInject */
  constructor(private splitService) {
    this.siteCurrencySymbol = this.splitService.getCurrencySymbol();
  }

}

angular
  .module('bringoz.admin.pricePlan')
  .component('additionsTableRow', {
    require: {
      additionsTableCtrl: '^additionsTable'
    },
    bindings: {
      addition: '<',
      settingsValue: '<?',
      onPriceChange: '&',
      onSettingsValueChange: '&'
    },
    template: require('./additions-table-row.html').default,
    controller: AdditionsTableRowCtrl
  });
